<template>
  <aside class="sidebar">
    <nav>
      <ul>
        <li :class="{ active: activePage === 'accueil' }" @click="goTo('accueil')">
          <span class="dot">▪</span>
          <span class="label">Accueil</span>
          <span class="icon-home">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 10.5L12 4L21 10.5V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V10.5Z" stroke="#cbb87c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 21V12H15V21" stroke="#cbb87c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </li>
        <li :class="{ active: activePage === 'contrats' }" @click="goTo('contrats')">
          <span class="dot">▪</span>
          <span class="label">Liste des contrats</span>
        </li>
        <li :class="{ active: activePage === 'alertes' }" @click="goTo('alertes')">
          <span class="dot">▪</span>
          <span class="label">Alertes / Échéances</span>
        </li>
        <li :class="{ active: activePage === 'biens' }" @click="goTo('biens')">
          <span class="dot">▪</span>
          <span class="label">Gestions des biens</span>
        </li>
        <!-- <li :class="{ active: activePage === 'clients' }" @click="goTo('clients')">
          <span class="dot">▪</span>
          <span class="label">Clients</span>
        </li> -->
      </ul>
    </nav>
  </aside>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

// Map route name to sidebar key
const routeToKey = {
  'DashboardAssist': 'accueil',
  'Contrats': 'contrats',
  'Alertes': 'alertes',
  'GestionBiens': 'biens',
  'Clients': 'clients',
}

const activePage = ref(routeToKey[route.name] || 'accueil')

function goTo(key) {
  activePage.value = key
  // Map sidebar key to route
  const keyToRoute = {
    'accueil': { name: 'DashboardAssist' },
    'contrats': { name: 'Contrats' },
    'alertes': { name: 'Alertes' },
    'biens': { name: 'GestionBiens' },
    'clients': { name: 'Clients' },
  }
  if (keyToRoute[key]) router.push(keyToRoute[key])
}
</script>

<script>
export default {
  name: 'AppSidebar',
}
</script>

<style scoped>
.sidebar {
  width: 270px;
  background: #ededed;
  height: calc(100vh - 70px); /* 70px = navbar height */
  position: fixed;
  top: 70px;
  left: 0;
  box-shadow: 1px 0 6px rgba(0,0,0,0.04);
  z-index: 10;
  border-right: 1px solid #e0e0e0;
}
.sidebar nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.sidebar nav li {
  display: flex;
  align-items: center;
  font-size: 1.7rem;
  color: #22305a;
  font-weight: 500;
  padding: 18px 18px 18px 24px;
  border-bottom: 2px solid #f4f4f4;
  cursor: pointer;
  background: #ededed;
  transition: background 0.2s;
}
.sidebar nav li.active {
  background: #1a2a4f;
  color: #cbb87c;
  font-weight: 700;
}
.sidebar nav li.active .label {
  color: #cbb87c;
}
.sidebar nav li.active .icon-home svg path {
  stroke: #cbb87c;
}
.sidebar nav li .dot {
  margin-right: 10px;
  font-size: 1.5rem;
}
.sidebar nav li .label {
  flex: 1;
  color: #22305a;
  font-size: 1.25rem;
  font-weight: 500;
}
.sidebar nav li .icon-home {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.sidebar nav li:not(.active):hover {
  background: #e0e6f6;
}
</style> 